import React from "react";
import { useParams } from "react-router-dom";
import Seo from "../components/Seo";
import PageIntro from "../components/qa/PageIntro";
import { contact, getCopy } from "../content/portfolio";

export function Privacy() { return <LegalPage type="privacy" />; }
export function Legal() { return <LegalPage type="legal" />; }
function LegalPage({ type }) {
  const { locale = "de" } = useParams();
  const copy = getCopy(locale).legal;
  const title = type === "privacy" ? copy.privacyTitle : copy.legalTitle;
  const eyebrow = type === "privacy" ? copy.privacyEyebrow : copy.legalEyebrow;
  const description = type === "privacy" ? copy.privacy : copy.legalIntro;

  return <div className="page-wrapper legal-page">
    <Seo locale={locale} metadata={{ title: `${title} – Anton Rost`, description }} path={type === "privacy" ? "/privacy" : "/legal"} />
    <PageIntro titleId={`${type}-title`} eyebrow={eyebrow} title={title} intro={type === "legal" ? copy.legalIntro : undefined} />
    <section className="content-wrapper legal-details" aria-label={title}>
      {type === "privacy" ? <PrivacyDetails copy={copy} locale={locale} /> : <ImprintDetails copy={copy} locale={locale} />}
    </section>
  </div>;
}

function Address({ locale }) {
  return <address className="bodycopy legal-address">
    <span>{contact.fullName}</span>
    <span>{contact.street}</span>
    <span>{contact.postalCode} {contact.city}</span>
    <span>{locale === "de" ? "Deutschland" : "Germany"}</span>
  </address>;
}

function PrivacyDetails({ copy, locale }) {
  return <div className="qa-text-grid legal-card-grid">
    <article className="qa-module-card legal-card">
      <h2 className="h4">{copy.privacyController}</h2>
      <Address locale={locale} />
      <a className="bodycopy" href={`mailto:${contact.email}`}>{contact.email}</a>
    </article>
    <article className="qa-module-card legal-card">
      <h2 className="h4">{copy.privacyEyebrow}</h2>
      <p className="bodycopy">{copy.privacy}</p>
    </article>
  </div>;
}

function ImprintDetails({ copy, locale }) {
  return <div className="qa-text-grid legal-card-grid">
    <article className="qa-module-card legal-card">
      <h2 className="h4">{copy.providerTitle}</h2>
      <p className="bodycopy legal-name">{contact.fullName}</p>
    </article>
    <article className="qa-module-card legal-card">
      <h2 className="h4">{copy.addressTitle}</h2>
      <Address locale={locale} />
    </article>
    <article className="qa-module-card legal-card">
      <h2 className="h4">{copy.contactTitle}</h2>
      <ul className="legal-links">
        <li><a className="bodycopy" href={`mailto:${contact.email}`}>{contact.email}</a></li>
        <li><a className="bodycopy" href={`tel:${contact.phoneHref}`}>{contact.phone}</a></li>
        <li><a className="bodycopy" href={contact.website}>{copy.websiteLabel}</a></li>
        <li><a className="bodycopy" href={contact.linkedin} target="_blank" rel="noreferrer">{copy.linkedinLabel}</a></li>
      </ul>
    </article>
    <article className="qa-module-card legal-card">
      <h2 className="h4">{copy.vatTitle}</h2>
      <p className="bodycopy">{copy.vatLabel}</p>
      <p className="bodycopy legal-vat">{contact.vatId}</p>
    </article>
  </div>;
}
